import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { User } from '../../types'
import type { RootState } from '../index'

interface UserState {
  isAuthenticated: boolean
  user: User | null
}

const initialState: UserState = {
  isAuthenticated: false,
  user: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload
      state.isAuthenticated = true
    },
    updateUser(state, action: PayloadAction<Partial<User>>) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
    logout(state) {
      state.isAuthenticated = false
      state.user = null
    },
  },
})

// Selectors
export const selectUser = (state: RootState) => state.user.user
export const selectIsAuthenticated = (state: RootState) => state.user.isAuthenticated
export const selectIsLead = (state: RootState) => state.user.user?.clientKind === 'lead'
export const selectFullName = (state: RootState) => {
  const u = state.user.user
  if (!u) return ''
  return `${u.lastName} ${u.firstName} ${u.middleName}`.trim()
}
export const selectShortName = (state: RootState) => {
  const u = state.user.user
  if (!u) return ''
  const firstInitial = u.firstName.charAt(0)
  const middleInitial = u.middleName ? u.middleName.charAt(0) + '.' : ''
  return `${u.lastName} ${firstInitial}. ${middleInitial}`.trim()
}

export const { setUser, updateUser, logout } = userSlice.actions
export default userSlice.reducer
